'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

export default function BackgroundPortal() {
  const pathname = usePathname();
  const [isShow, setIsShow] = useState(false);

  useEffect(() => {
    if (
      pathname === '/' ||
      pathname === '/myTravels' ||
      pathname === '/savedPois' ||
      pathname.startsWith('/poi/') ||
      pathname.startsWith('/travelCard/')
    ) {
      setIsShow(true);
    } else {
      setIsShow(false);
    }
  }, [pathname]);

  return (
    <div
      id='background-portal'
      className={`fixed w-full h-full ${isShow ? 'bg-gradient-to-b from-new-point-100 to-white' : ''}`}
    ></div>
  );
}
